import { styled } from '@mui/material/styles';
import { NavigationSidebar } from './AppNavigation/Components/NavigationSidebar';
import { menuWidthSmall } from './AppLayout.styles';
import { ScrollArea } from '../ScrollArea/ScrollArea';

const RootLayoutContent = styled('div')(({ theme }) => ({
  position: 'relative',
  marginLeft: theme.spacing(menuWidthSmall),
}));

const RootLayoutScrollAreaContent = styled('div', { name: 'RootLayoutScrollArea' })(
  ({ theme }) => ({
    paddingRight: theme.spacing(22),
    paddingLeft: theme.spacing(24),
    minHeight: '100%',
    height: '1px', //css hack for resolve problem with min-height and child with height: 100%
  }),
);

export const RootLayout = ({ children }: { children: React.ReactNode }) => {
  return (
    <div>
      <NavigationSidebar />
      <RootLayoutContent>
        <ScrollArea style={{ height: '100vh' }}>
          <RootLayoutScrollAreaContent>{children}</RootLayoutScrollAreaContent>
        </ScrollArea>
      </RootLayoutContent>
    </div>
  );
};
